import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import copyItem from '../../../../../../actions/copyItem';
import copyItems from '../../../../../../actions/copyItems';
import DuplicateItem from './DuplicateItem';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => bindActionCreators({ copyItem, copyItems }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateItem);
